import { Stack, type SxProps } from "@mui/material";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";

export interface AgreementItemProps {
  title: string;
  description: string;
  isSigned?: boolean;
  sx?: SxProps;
}

export function AgreementItem(props: AgreementItemProps) {
  const { title, description, isSigned = false, sx } = props;

  return (
    <Stack
      direction="row"
      alignItems="start"
      spacing={4}
      sx={{
        width: "100%",
        paddingY: 2,
        // oxlint-disable-next-line typescript/no-misused-spread -- MUI SxProps union includes functions, but spreading in sx is standard MUI pattern
        ...sx,
      }}
    >
      <Illustration
        type={isSigned ? "document-approved-small" : "document-review-small"}
        sx={{ width: 48, height: 48, flexShrink: 0 }}
      />

      <Stack direction="column" spacing={1} paddingTop={3}>
        <Text semibold variant="h5">
          {title}
        </Text>
        <Text
          variant="body1"
          sx={(theme) => ({ color: theme.palette.text.secondary })}
          paddingTop={1}
        >
          {description}
        </Text>
      </Stack>
    </Stack>
  );
}
